import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { loginSucesso } from '../../redux/actions/autenticacaoAction';
import { exibirMensagem } from '../../redux/actions/mensagemAction';
import ambiente from '../../config/ambienteConfig';

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      senha: '',
      redirecionar: false,
    };
  }

  handleSave = async () => {
    try {
      const res = await axios.post(`${ambiente.dev.server}/signin`, this.state);
      axios.defaults.headers.common['Authorization'] = `JWT ${res.data.token}`;
      this.props.loginSucesso(res.data.nome);
      this.props.exibirMensagem('info', `Bem vindo, ${res.data.nome}!`);
      this.setState({ redirecionar: true });
    } catch (err) {
      this.props.exibirMensagem('err', `Erro: ${err}`);
    }
  }

  render() {
    // const {from} = this.props.location.state || { from: { pathname: '/' }};
    if (this.state.redirecionar)
      return <Redirect to="/" />;

    return (
      <div className="jumbotron">
        <div className="form-group">
          <div className="input-group">
            <div className="input-group-addon">@</div>
            <input type="text" className="form-control" autoFocus
              placeholder="seu@email.com" value={this.state.email}
              onChange={evt => this.setState({ email: evt.target.value })} />
          </div>
        </div>
        <div className="form-group">
          <input type="password" className="form-control"
            placeholder="Senha" value={this.state.senha}
            onChange={evt => this.setState({ senha: evt.target.value })} />
        </div>
        <button type="submit" className="btn btn-block btn-primary" onClick={this.handleSave}>Entrar</button>
      </div>
    );
  }
}

LoginForm.propTypes = {
  loginSucesso: PropTypes.func.isRequired,
  exibirMensagem: PropTypes.func.isRequired
};

function mapStateToProps({ nomeUsuario }) {
  return {
    nomeUsuario
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loginSucesso: nomeUsuario => dispatch(loginSucesso(nomeUsuario)),
    exibirMensagem: (tipo, texto) => dispatch(exibirMensagem(tipo, texto))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);



// WEBPACK FOOTER //
// ./src/components/autenticacao/LoginForm.js